import { Injectable } from '@angular/core';
import { AuthenticationService } from './auth.service';
import { environment } from '../../environments/environment';
import { HttpClient,HttpHeaders  } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  base_uri: string;
  print_url: string;
  filemgr_url: string;
  // decodedToken;
  constructor(private authService: AuthenticationService, private http: HttpClient) {
    this.base_uri = environment.reports_url;
    // this.decodedToken = this.authService.getDecodedToken();
  }

  contactForDemo(data){
    // let hospital = this.authService.getDecodedToken()['hospital'];
    let url = this.base_uri + 'website/contact_us'

    // data.hospital_id = hospital;
    return this.http.post(url, data, {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    });
  }

  sendJobApplication(data){
    // let hospital = this.authService.getDecodedToken()['hospital'];
    let url = this.base_uri + 'website/career'

    // data.hospital_id = hospital;
    return this.http.post(url, data, {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    });
  }


}
